<template>
    <div class="rivacypolicy">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答第三方服务协议》</h1>
                    <div>《壹米滴答第三方服务协议》（以下简称"本协议"）是壹米滴答有限公司（以下简称"壹米滴答"或"我们"）与用户（以下简称"您"）就您使用壹米滴答小程序第三方服务事项所订立的有效合约。请您先仔细阅读本协议内容，尤其是字体加粗部分。</div>
                    <div style="margin-top: 5px;">如您对本协议内容或页面提示信息有疑问，请勿进行下一步操作。您可通过壹米滴答在线客服95058或官方热线咨询，以便我们为您解释和说明。如您通过页面点击、使用本服务或我们认可的其他方式确认本协议，即表示您已同意本协议。</div>
                    <div><span style="font-weight: bold;line-height: 40px;">一、服务声明</span></div>
                    <div>壹米滴答和您均同意并理解以下内容：</div>
                    <div>1.壹米滴答小程序仅是中立的技术支持服务提供者，仅提供网页空间、信息传输等中立技术支持服务。</div>
                    <div>2.壹米滴答小程序仅在小程序内设置了第三方服务的服务入口，以便提高您的服务体验及更便捷地购买第三方的产品或服务。产品或服务由第三方服务商自行开发、运营，且由第三方服务商自行承担全部责任。壹米滴答不参与第三方服务商的产品开发、运营等环节，也不会对服务商产品的代码、数据等任何内容进行修改、编辑或整理。</div>
                    <div>3.壹米滴答与第三方服务商是独立的法律主体。因第三方服务商的产品、服务及相关内容等产生的任何纠纷、责任，或因第三方服务商违反相关法律法规或本协议约定引发的任何后果，均由第三方服务商独立承担责任、赔偿损失，与壹米滴答无关。</div>
                    <div><span style="font-weight: bold;line-height: 40px;">二、用户的权利义务</span></div>
                    <div>1.您可根据自身需求，自行决定是否购买、使用壹米滴答小程序内第三方服务商提供的产品或服务。您在购买、使用具体产品或服务前，请审慎了解该产品或服务的功能、要求、收费标准及退费规则等详细内容；如您对具体产品或服务有异议，请勿以任何方式购买或使用。因购买、使用第三方产品或服务产生的任何纠纷，您应与第三方服务商协商解决。</div>
                    <div>2.您向第三方服务商购买产品后，如需发票等支付凭证或服务单据，应向第三方服务商提出申请，由第三方服务商依法承担开具并邮寄相应发票、支付凭证或服务单据的责任。</div>
                    <div>3.您在使用第三方服务时，请勿随意透露自身的财产账户、银行卡、信用卡及对应密码等重要资料；如因您自身泄露上述信息导致损失，由您自行承担。</div>
                    <div>4.第三方服务商可能因自身运营规划调整、违约被追究责任、产品侵犯他人知识产权被禁止销售等原因，导致其服务入口从壹米滴答小程序中移除。该等情况非因壹米滴答过错导致，您应直接向第三方服务商主张权利。</div>
                    <div><span style="font-weight: bold;line-height: 40px;">三、壹米滴答的权利与义务</span></div>
                    <div>1.壹米滴答仅负责壹米滴答小程序自身服务的运营和维护，并承担因自身服务产生的用户咨询和纠纷处理责任。与第三方服务商产品或服务相关的全部事务（包括但不限于用户咨询解答、投诉处理、纠纷解决等），均由第三方服务商自行负责。</div>
                    <div>2.壹米滴答可能基于法律法规要求、业务内容调整等必要情况，更新或修改本协议条款，并通过壹米滴答小程序系统提示、页面公告等方式通知您。修改后的协议一旦在小程序相关服务页面公布，即有效替代原协议内容，您可在该页面查阅最新版本协议条款。如您不接受修改后的协议，应停止使用本服务；否则，您对相关服务的登录、查看等任何使用行为，将视为您对修改后协议的理解和接受。</div>
                    <div>3.保护用户数据是壹米滴答的基本原则。除法律规定、有法律赋予权限的政府部门要求或您同意等合理原因外，未经您的同意，壹米滴答不会向第三方公开、透露您的信息，但以下情形除外：</div>
                    <div>（1）您明确同意壹米滴答向第三方提供的；</div>
                    <div>（2）依据法律法规规定，或依据本协议及其他相关协议、规则约定可提供的；</div>
                    <div>（3）为防止严重违法行为或涉嫌犯罪行为发生，采取必要合理行动所必须提供的。</div>
                    <div>4.您理解并同意，壹米滴答小程序仅设置第三方服务的服务入口，并为第三方服务商提供信息服务等中立技术支持；您购买或使用的第三方产品/服务，由第三方服务商直接提供。壹米滴答对第三方产品/服务不作任何类型的担保（包括但不限于真实性、适用性、非侵权性等，无论明确或隐含），且不参与第三方产品的开发、运营。因第三方产品/服务发生的任何纠纷，由第三方服务商与您协商解决，相关责任和赔偿由第三方服务商单独承担。</div>
                    <div>5.壹米滴答有权提前30个自然日，通过壹米滴答小程序线上公告、站内信等方式，通知您终止运营本服务，且无需承担任何责任。</div>
                    <div><span style="font-weight: bold;line-height: 40px;">四、用户个人信息保护</span></div>
                    <div>1.您在使用第三方服务商提供的产品或服务（以下简称"第三方产品/服务"）过程中，第三方服务商可能需要单独收集和使用您的相关个人信息。壹米滴答将要求第三方服务商遵循相关法律法规要求及隐私保护原则。您在购买、使用第三方产品/服务前，请审慎确认该产品/服务是否符合隐私保护要求，并仔细阅读第三方服务商的个人信息收集使用规则；如您对该产品/服务的隐私保护规则有异议，请勿购买或使用。如您在购买、使用后产生个人信息保护相关纠纷，应与第三方服务商协商解决。</div>
                    <div>2.为方便您使用第三方服务，若您在壹米滴答小程序"用户信息授权"界面点击授权同意，壹米滴答将按照您授权的范围（包括授权对象、授权目的、授权信息类型），通过加密通道将您的相关信息传递给第三方服务商。壹米滴答将要求第三方服务商严格遵守相关法律法规与监管要求，依法使用您的信息，并对您的信息承担保密责任。</div>
                    <div>3.您授权后，可通过<span @click="toPrivacyPolicy" class="text_link">《壹米滴答隐私政策》</span>中载明的联系方式，联系我们解除授权或行使个人信息相关权利（如查询、更正、删除等）。您撤回个人信息授权的行为，不影响第三方服务商基于您此前授权已完成的个人信息处理行为的效力。</div>
                    <div>4.如您未在壹米滴答小程序"用户信息授权"界面点击授权同意，可能无法通过小程序内的第三方服务入口购买、使用第三方服务商提供的服务。</div>
                    <div><span style="font-weight: bold;line-height: 40px;">五、其他</span></div>
                    <div>1.本协议未约定的事宜，以壹米滴答官方网站或小程序公布的<span @click="toPrivacyPolicy" class="text_link">《壹米滴答隐私政策》</span>《壹米滴答用户协议》及相关规则为准；本协议与<span @click="toPrivacyPolicy" class="text_link">《壹米滴答隐私政策》</span>《壹米滴答用户协议》及相关规则内容不一致的，以本协议为准。</div>
                    <div>2.本协议的效力、解释、变更、执行及争议解决，均适用中华人民共和国法律（不包括港澳台地区法律）。因本协议产生的任何争议，双方应首先协商解决；协商不成的，任何一方可向壹米滴答所在地有管辖权的人民法院提起诉讼。</div>
                    <div style="height: 20px;"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {},
    methods: {
        // 跳转到隐私政策
        toPrivacyPolicy() {
            this.$router.push({
                path: "/rivacypolicy",
                query: {
                    id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .text_link {
            color: #FFAF00;
            font-weight: bold;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
                color: #ff9500;
            }
        }
    }
}
</style>

